import React from 'react';

import { bemBlock } from '@neptune/shared/venus-ui';

import { Token } from './diff';

import './Comparison.less';

const block = bemBlock('comparison');

export const Comparison = ({ tokens }: { tokens: Token[] }) => (
  <>
    {tokens.map((token: Token, idx) => {
      if (typeof token === 'string') {
        return <span key={token + idx}>{token}</span>;
      }

      const cssClass = block({
        element: 'fragment',
        modifiers: {
          deletion: token[1] === 'd',
          insertion: token[1] === 'i',
          substitution: token[1] === 's',
        },
      });

      return (
        <span key={token[0] + idx} className={cssClass}>
          {token[0]}
        </span>
      );
    })}
  </>
);
